import { render, staticRenderFns } from "./BaseAuthButton.vue?vue&type=template&id=5ecf855e"
import script from "./BaseAuthButton.vue?vue&type=script&lang=js"
export * from "./BaseAuthButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports